$(document).ready(function() {
    $('.btn-guide').click(function(event) {
        let target = $(this).attr('href');
        let targetPosition = $(target).offset().top;
        $('html, body').animate({ scrollTop: targetPosition }, 500);
    });

    /* 至頂 */
    $('#btn-top').click(function(event) {
        event.preventDefault();
        $('html').animate({
            scrollTop: 0
        }, 250);
    });
});

/* 滾動監聽 */
window.onscroll = scroll;

function scroll() {
    //console.log(window.pageYOffset);
    if (window.pageYOffset < 300) {
        document.getElementById('btn-top').classList.add('d-none');
        document.getElementById('btn-top').classList.remove('d-block');
    } else {
        document.getElementById('btn-top').classList.remove('d-none');
        document.getElementById('btn-top').classList.add('d-block');
    };
};